export const UPDATE_DURATION_SOURCE = {
  scaler: 'scaler',
  learner: 'learner',
};
